'use strict';
/**
 * [init initilizes tabs]
 * @param  {[string]} scope [css selector]
 * @return {[undefined]}    [nothing returned]
 */
export function init(scope) {
    if (jQuery.validator) {
        jQuery.validator.setDefaults({
            showErrors: function(errorMap, errorList) {
                var ul = $("#validation-summary-cart ul");
                if (ul&&ul.length) {
                    if (this.numberOfInvalids()===0 || (errorList && errorList.length > 0)) {
                        ul.empty();

                        $.each(errorMap, function(key, value) {
                            ul.append("<li>" + value + "</li>");
                        });
                    }
                }
                this.defaultShowErrors();
            },
            highlight: function(element, errorClass, validClass) {
                $(element).closest('.fu').addClass('error');

                //for lottery and support membership page
                var customErrors = $('div.custom-detailed-errors');
                if (customErrors && customErrors.length) {
                    var elementName = $(element).attr('name');
                    var elementsWithName = $('li[name="' + elementName + '"]');
                    var elementInDiv = customErrors.find(elementsWithName);
                    if (elementInDiv && elementInDiv.length) {
                        var currentElementError = elementInDiv.removeClass('hidden').show();
                        if (currentElementError.closest('div').hasClass('hide')) {
                            currentElementError.closest('div').removeClass('hide');
                        }
                    }
                } else {
                    var form = $(element).closest('form');

                    if (form) {
                        //for cart page
                        var valSum = form.find('#validation-summary-cart');
                        if (valSum && valSum.length) {
                            valSum.parent('div.error').show();
                            $('html, body').end().animate({ scrollTop: form.offset().top - 100 }, 500);
                        }
                    }
                }
            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).closest('.fu').removeClass('error');

                var customErrors = $('div.custom-detailed-errors');
                if (customErrors && customErrors.length) {
                    var elementName = $(element).attr('name');
                    var elementsWithName = $('li[name="' + elementName + '"]');
                    var elementInDiv = customErrors.find(elementsWithName);
                    if (elementInDiv && elementInDiv.length) {
                        var currentElementError = elementInDiv.addClass('hidden').hide();
                        var divElement = currentElementError.closest('div');
                        if (divElement.find('li.hidden').length == divElement.find('li').length) {
                            divElement.addClass('hide');
                        }
                    }
                } else {

                    var valSum = $('#validation-summary-cart');

                    if (valSum && valSum.length && !this.errorList.length > 0) {
                        valSum.parent('div.error').hide();
                    }
                }
            },
            onkeyup: false,
            onfocusout: function (element, event) {
                var target = $(event.relatedTarget);
                if (!target.is(':button') && !target.is(':submit')) {
                    this.element(element);
                }
            }
        });
    }
}